import type { ComponentProps } from "react";
import { cn } from "./cn";
import { Icon } from "./icon";
import { controlClasses } from "./input";

/**
 * A native `<select>` with the look of the kit. It is native on purpose: the browser gives it keyboard, touch and screen-reader behaviour
 * for free, and a staff member on a phone gets the system picker.
 */
export function Select({ className, children, ...props }: ComponentProps<"select">) {
  return (
    <span className="relative block w-full min-w-0">
      <select
        className={cn(
          controlClasses,
          // A `select` matches `:read-only`, so the grey of a read-only text field would show on it. A select is white like the other controls.
          "h-11 cursor-pointer appearance-none pr-9 read-only:bg-card compact:h-8",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <Icon
        name="arrow-down-01-round"
        className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </span>
  );
}
